/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressFromJSON, AddressToJSON, AgreementFromJSON, AgreementToJSON, ApplicationUserFromJSON, ApplicationUserToJSON, CarCollectionFromJSON, CarCollectionToJSON, ContactPersonFromJSON, ContactPersonToJSON, ReservationFromJSON, ReservationToJSON, } from './';
export function CustomerFromJSON(json) {
    return CustomerFromJSONTyped(json, false);
}
export function CustomerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'nip': !exists(json, 'nip') ? undefined : json['nip'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'fkId': !exists(json, 'fkId') ? undefined : json['fkId'],
        'isActive': json['isActive'],
        'isDeleted': json['isDeleted'],
        'languageCode': !exists(json, 'languageCode') ? undefined : json['languageCode'],
        'addresses': !exists(json, 'addresses') ? undefined : (json['addresses'] === null ? null : json['addresses'].map(AddressFromJSON)),
        'contacts': !exists(json, 'contacts') ? undefined : (json['contacts'] === null ? null : json['contacts'].map(ContactPersonFromJSON)),
        'reservations': !exists(json, 'reservations') ? undefined : (json['reservations'] === null ? null : json['reservations'].map(ReservationFromJSON)),
        'agreements': !exists(json, 'agreements') ? undefined : (json['agreements'] === null ? null : json['agreements'].map(AgreementFromJSON)),
        'carCollectionId': !exists(json, 'carCollectionId') ? undefined : json['carCollectionId'],
        'carCollection': !exists(json, 'carCollection') ? undefined : CarCollectionFromJSON(json['carCollection']),
    };
}
export function CustomerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'nip': value.nip,
        'companyName': value.companyName,
        'fkId': value.fkId,
        'isActive': value.isActive,
        'isDeleted': value.isDeleted,
        'languageCode': value.languageCode,
        'addresses': value.addresses === undefined ? undefined : (value.addresses === null ? null : value.addresses.map(AddressToJSON)),
        'contacts': value.contacts === undefined ? undefined : (value.contacts === null ? null : value.contacts.map(ContactPersonToJSON)),
        'reservations': value.reservations === undefined ? undefined : (value.reservations === null ? null : value.reservations.map(ReservationToJSON)),
        'agreements': value.agreements === undefined ? undefined : (value.agreements === null ? null : value.agreements.map(AgreementToJSON)),
        'carCollectionId': value.carCollectionId,
        'carCollection': CarCollectionToJSON(value.carCollection),
    };
}
